{
  "name": "mobile-storehouse",
  "version": "0.8.34",
  "scripts": {
    "ng": "ng",
    "start": "rm -rf .angular node_modules/.vite && ng cache clean && ng serve",
    "build": "ng build --configuration development",
    "buildProd": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:vi": "vitest",
    "test:ui": "vitest --ui",
    "test:run": "vitest run",
    "cache:clean": "ng cache clean ",
    "sdk": "ng cache clean && rm -rf 'src/dataconnect-account' && firebase dataconnect:sdk:generate --watch",
    "init:sdk": "npx -y firebase-tools@latest init dataconnect:sdk --project mobile-storehouse-dev",
    "cc": "stripe listen --skip-verify --load-from-webhooks-api --latest --forward-to localhost:5001/mobile-storehouse-dev/us-central1/",
    "fbReauth": "firebase login --reauth",
    "emuBlank": "firebase emulators:start --only auth,firestore,storage,functions",
    "zzzEmu": "firebase emulators:start --import=emulatorData --only auth,firestore,storage,functions",
    "emu": "firebase emulators:start --import=emulatorData --only auth,firestore,storage,functions,dataconnect",
    "emu+": "rm -rf ./dataconnect/.dataconnect && y | GOOGLE_APPLICATION_CREDENTIALS=\"/Users/greghowle/Documents/Mobile Storehouse/Site/Source/Mobile Storehouse/functions/environments/environment.local.json\" FIREBASE_DEBUG=true npx -y firebase-tools@latest emulators:start --project mobile-storehouse-dev --import ./emulatorData ",
    "emu-": "rm -rf ./dataconnect/.dataconnect && y | GOOGLE_APPLICATION_CREDENTIALS=\"/Users/greghowle/Documents/Mobile Storehouse/Site/Source/Mobile Storehouse/functions/environments/environment.local.json\" FIREBASE_DEBUG=true npx -y firebase-tools@latest emulators:start --project mobile-storehouse-dev ",
    "dataconnect-sql-diff": "node -r dotenv/config /Users/greghowle/.nvm/versions/node/v22.19.0/bin/firebase dataconnect:sql:diff",
    "diff": "firebase dataconnect:sql:diff",
    "saveEmuData": "firebase emulators:export emulatorData",
    "deployToDev": "firebase use dev && cd functions && npm run build && cd ../ && npm run build && firebase deploy"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.12",
    "@angular/cdk": "^21.2.10",
    "@angular/common": "^21.2.12",
    "@angular/compiler": "^21.2.12",
    "@angular/core": "^21.2.12",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "^21.2.12",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.12",
    "@angular/platform-browser-dynamic": "^21.2.12",
    "@angular/router": "^21.2.12",
    "@dataconnect/account": "file:src/dataconnect-account",
    "@ngrx/entity": "^21.1.0",
    "@ngrx/router-store": "^21.1.0",
    "@ngrx/store": "^21.1.0",
    "@ngrx/store-devtools": "^21.1.0",
    "@stripe/stripe-js": "^8.0.0",
    "@tanstack-query-firebase/angular": "^1.0.2",
    "dotenv": "^17.2.2",
    "exif-js": "^2.3.0",
    "firebase": "11.10.0",
    "heic-to": "^1.5.2",
    "js-confetti": "^0.13.1",
    "ngrx-store-localstorage": "^19.0.2",
    "rxjs": "~7.8.0",
    "shippo": "^2.15.0",
    "tslib": "^2.3.0",
    "uuid": "^13.0.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.5.0",
    "@analogjs/vitest-angular": "^2.5.0",
    "@angular-devkit/build-angular": "^21.2.10",
    "@angular/build": "^21.2.10",
    "@angular/cli": "^21.2.10",
    "@angular/compiler-cli": "^21.2.12",
    "@types/google.maps": "^3.58.1",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^25.6.0",
    "@types/shippo": "^1.7.8",
    "@vitest/browser-playwright": "^4.0.0",
    "@vitest/ui": "^4.1.5",
    "autoprefixer": "^10.4.21",
    "baseline-browser-mapping": "^2.9.0",
    "firebase-tools": "15.7.0",
    "jasmine-core": "~5.5.0",
    "jsdom": "^29.1.1",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "playwright": "^1.54.0",
    "postcss": "^8.5.6",
    "tailwindcss": "^3.4.17",
    "typescript": "~5.9.3",
    "vite": "^7.0.0",
    "vite-tsconfig-paths": "^4.2.0",
    "vitest": "^4.0.0",
    "webpack-bundle-analyzer": "^4.10.2"
  }
}
